import { Text, TextProps } from '@chakra-ui/react';
import {
    FinancialEntityMaskBaseProps,
    getFinancialEntityWithMaskParams,
} from '@common/react/financialEntities/FinancialEntityWithMask';
import { useCurrentUser } from '@common/react/user';

interface FinancialEntityMaskProps
    extends FinancialEntityMaskBaseProps,
        TextProps {}

const FinancialEntityWithMask = ({
    fe,
    showName = true,
    showMask = true,
    asString = false,
    showOwnership = false,
    ...props
}: FinancialEntityMaskProps) => {
    const { userInfo, partnerInfo } = useCurrentUser();
    const { name, mask, ownershipStr } = getFinancialEntityWithMaskParams({
        fe,
        userInfo,
        partnerInfo,
    });

    if (asString) {
        return (
            <>
                {showOwnership && ownershipStr && `${ownershipStr}\u00A0`}
                {showName && name}
                {showMask && mask && (
                    <>
                        {' .... '}
                        {mask}
                    </>
                )}
            </>
        );
    }

    return (
        <>
            {showOwnership && ownershipStr && `${ownershipStr}\u00A0`}
            {showName && name}
            {showMask && mask && (
                <>
                    {' .... '}
                    <Text as="span" fontFamily="mono" {...props}>
                        {mask}
                    </Text>
                </>
            )}
        </>
    );
};

export default FinancialEntityWithMask;
